import { render, staticRenderFns } from "./SmallCategoryShowModal.vue?vue&type=template&id=5e04e3b5&scoped=true"
import script from "./SmallCategoryShowModal.vue?vue&type=script&lang=js"
export * from "./SmallCategoryShowModal.vue?vue&type=script&lang=js"
import style0 from "./SmallCategoryShowModal.vue?vue&type=style&index=0&id=5e04e3b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e04e3b5",
  null
  
)

export default component.exports